/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from "moment";
import * as types from "./types";

export const state = {
  list: [],
  partnerPayment: {},
  filtersInitialDate: moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  filtersFinalDate: moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  filtersPaymentInitialDate: moment()
    .startOf("year")
    .format("YYYY-MM-DD"),
  filtersPaymentFinalDate: moment()
    .add(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD"),
  filtersCardBrand: "",
  filtersTerminalNumber: "",
  filtersStatus: "",
  filtersOperation: "",
  filtersOrdination: "",
  limitOptions: [10, 25, 50, 100],
  totalResources: 0,
  currentPage: 1,
  limit: 10,
  loadingData: false,
  subtotal: 0,
  transactedTotal: 0,
  settledTotal: 0,
  devicesCount: 0,
  filterStatus: false,
  newPayment: [],
  updateSubscription: [],
  newPaymentStatus: false,
  newPaymentError: false,
  showFilters: false,
  filtersPartner: "",
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_created_at_between: {
        start_at: null,
        end_at: null,
      },
      status: null,
      credit_card_brand: null,
      with_terminal_number: null,
      operation: null,
      with_partner: null,
      sorted_by: null,
      with_account_id: null
    }
  }
};

export const mutations = {
  [types.FILTER_STATUS](state, status) {
    state.filterStatus = status;
  },
  [types.SET_PARTNER_PAYMENTS_SUBTOTAL](state, subtotal) {
    state.subtotal = subtotal;
  },
  [types.SET_PARTNER_PAYMENTS_SUMMARY](state, summary) {
    state.transactedTotal = Number(summary.transacted_total) || 0;
    state.settledTotal = Number(summary.settled_total) || 0;
    state.devicesCount = Number(summary.devices_count) || 0;
  },
  [types.SET_FILTER_ACCOUNT_ID](state, accountId) {
    state.filterParams.filterrific.with_account_id = accountId || null;
  },
  [types.SET_PARTNER_PAYMENTS_LIST](state, list) {
    state.list = list;
  },
  [types.SET_PARTNER_PAYMENTS_LIST_ALL](state, listAll) {
    state.listAll = listAll;
  },
  [types.SET_PARTNER_PAYMENT_DATA](state, partnerPayment) {
    state.partnerPayment = partnerPayment;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.SET_FILTER_PAYMENT_INITIAL_DATE](state, date) {
    state.filtersPaymentInitialDate = date;
  },
  [types.SET_FILTER_PAYMENT_FINAL_DATE](state, date) {
    state.filtersPaymentFinalDate = date;
  },
  [types.SET_FILTER_CARD_BRAND](state, cardBrand) {
    state.filtersCardBrand = cardBrand;
  },
  [types.SET_FILTER_TERMINAL_NUMBER](state, terminalNumber) {
    state.filtersTerminalNumber = terminalNumber;
  },
  [types.SET_FILTER_OPERATION](state, operation) {
    state.filtersOperation = operation;
  },
  [types.SET_FILTER_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SET_FILTER_STATUS](state, status) {
    state.filtersStatus = status;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
    state.filterParams.page = page;
  },
  [types.SET_TOTAL_RESOURCES](state, total) {
    state.totalResources = total;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
    state.filterParams.limit = limit;
  },
  [types.LOADING_DATA](state, param) {
    state.loadingData = param;
    // console.log("Loading data mutation: " + param)
  },
  [types.NEW_PAYMENT](state, newPayment) {
    state.newPayment = newPayment;
  },
  [types.UPDATE_SUBSCRIPTION](state, updateSubscription) {
    state.updateSubscription = updateSubscription;
  },
  [types.NEW_PAYMENT_STATUS](state, newPaymentStatus) {
    state.newPaymentStatus = newPaymentStatus;
  },
  [types.NEW_PAYMENT_ERROR](state, newPaymentError) {
    state.newPaymentError = newPaymentError;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_FILTER_PARTNER](state, partner) {
    state.filtersPartner = partner;
  }
};
